import * as api from "../API/index";

//get validation uuid
export const validateQuotationUUID = async (uuid) => {
  try {
    const res = await api.validate_quotation_uuid(uuid);
    return res.data;
  } catch (err) {
    return err?.response?.data;
  }
};

//Update Quotation Status
export const updateQuotationStatus = async (uuid, bodyData) => {
  try {
    const res = await api.approve_and_reject_quotation(uuid, bodyData);
    return res.data;
  } catch (err) {
    return err?.response?.data;
  }
};

//Get Checkout ID
export const generateCheckoutID = async (bodyData) => {
  try {
    const res = await api.generate_CheckoutID(bodyData);
    return res.data;
  } catch (err) {
    return err?.response?.data;
  }
};

//Get Payment Status
export const getPaymentStatus = async (bodyData) => {
  try {
    const res = await api.check_payment_status(bodyData);
    return res.data;
  } catch (err) {
    return err?.response?.data;
  }
};

//Get Checkout ID
export const downloadPaymentReceipt = async (merchantID) => {
  try {
    const res = await api.download_payment_receipt(merchantID);
    return res.data;
  } catch (err) {
    return err?.response?.data;
  }
};
